/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import SmoothScroll from './SmoothScroll.component';

const Link = (props) => {
  const { targetRef, children, className } = props;
  return (
    <li className={'list__item--type-inline ' + (className === null ? '' : className)}>
      <SmoothScroll targetRef={targetRef} className="u__default-link">
        {children}
      </SmoothScroll>
    </li>
  );
};

Link.propTypes = {
  targetRef: PropTypes.shape({ current: PropTypes.any }),
  children: PropTypes.node,
  /** class modifiers. */
  className: PropTypes.string,
};
Link.defaultProps = {
  className: null,
  targetRef: null,
  children: null
};

export default Link;
